const translations = {
  app: {
    title: "Tunisia Hightech",
    slogan: "Welcome to Tunisia Hightech",
  },
  common: {
    dashboard: "Dashboard",
    newRepair: "New Repair",
    search: "Search",
    stock: "Stock & POS",
    searchRepairs: "Search Repairs",
    viewDetails: "View Details",
    clickToView: "Click to view",
    processing: "Processing...",
    submit: "Submit",
    cancel: "Cancel",
    delete: "Delete",
    optional: "optional",
    areYouSure: "Are you sure?",
    back: "Back to",
    loading: "Loading...",
    print: "Print",
    download: "Download",
    balance: "Balance",
    error: "Error!",
    info: "Info",
    pageNotFound: "Oops! Page not found",
    returnHome: "Return to Home",
    copied: "Copied to clipboard",
    call: "Call",
    startScanning: "Start Scanning",
    stopScanning: "Stop Scanning",
    scannerActive: "Scanner is active and ready",
    scannerInactive: "Scanner is inactive",
    logo: "Logo",
    repairShop: "Repair Shop",
    tel: "Tel",
    phone: "Phone",
    clear: "Clear",
    edit: "Edit",
    disabled: "Disabled",
    featureDisabledMessage: "This feature has been disabled for this store.",
    enterSecurityCode: "Enter security code",
    invalidSecurityCode: "Invalid security code. Please try again.",
    none: "None",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    status: "Status",
    actions: "Actions",
    save: "Save",
    saving: "Saving...",
    confirm: "Confirm",
    securityVerification: "Security Verification",
    enterSecurityCodeToConfirm:
      "Please enter the security code to confirm this action.",
    unknown: "Unknown",
    showing: "Showing",
    of: "of",
    repairs: "repairs",
    loadMore: "Load More",
  },
  repair: {
    createNew: "Create New Repair",
    customerInfo: "Customer Details",
    customerName: "Customer Name",
    customerPhone: "Phone Number",
    customerEmail: "Customer Email",
    phoneModel: "Device Model",
    stat: "Status",
    problemDescription: "Problem Description",
    observations: "Observations",
    observationsOptional: "(optional)",
    addObservation: "Add observation",
    noObservations: "No observations yet",
    observationAdded: "Observation added successfully",
    observationAddError: "Failed to add observation",
    repairPrice: "Repair Price",
    initialPrice: "Initial Price",
    totalPrice: "Total Price",
    paymentStatus: "Payment Status",
    downPayment: "Down Payment",
    priceModifications: "Price Modifications",
    priceModified: "Price has been modified",
    addPriceModification: "Add Price Modification",
    priceModificationAdded: "Price modification added successfully",
    priceModificationAddError: "Failed to add price modification",
    amount: "Amount",
    reason: "Reason",
    submitRepair: "Submit Repair",
    repairDetails: "Repair Details",
    repairTimeline: "Repair Timeline",
    statusChanged: "Status changed to",
    updateStatus: "Update Status",
    deleteRepair: "Delete Repair",
    deleteConfirmation:
      "Are you sure you want to delete this repair? This action cannot be undone.",
    enterDeleteCode: "Enter deletion code",
    invalidDeleteCode: "Invalid deletion code. Please try again.",
    successCreated: "Repair created successfully!",
    failedCreated: "Failed to create repair!",
    successUpdated: "Repair updated successfully!",
    successDeleted: "Repair deleted successfully!",
    notFound: "Repair not found",
    active: "Active",
    completed: "Completed",
    returned: "Returned",
    all: "All",
    noActiveRepairs: "No active repairs found",
    noCompletedRepairs: "No completed repairs found",
    noReturnedRepairs: "No returned repairs found",
    noRepairsFound: "No repairs found",
    createFirstRepair: "Create your first repair",
    addedAgo: "Added {{time}}",
    scanQrCode: "Scan this QR code to view repair details",
    scanBarcode: "Scan this barcode with 1D scanner",
    barcodeSticker: "Barcode Sticker",
    infoSticker: "Info Sticker",
    repairTicket: "Repair Ticket",
    ticketNumber: "Ticket Number",
    qrCode: "QR Code",
    selectCodeType: "Select Code Type",
    selectCodeTypeDescription:
      "Choose which type of code to include on the printed ticket",
    selectTicketLayout: "Select Ticket Layout",
    selectTicketLayoutDescription:
      "Choose the optimal layout for your scanner and printer setup",
    ticketLayout: "Ticket Layout",
    largeQrTop: "Large QR Code (Top)",
    largeQrTopDescription: "50x50px QR code at top for excellent 2D scanning",
    fullWidthBarcode: "Full-Width Barcode",
    fullWidthBarcodeDescription:
      "Maximum width barcode for reliable 1D scanning",
    qrLogoSideBySide: "QR + Logo Side-by-Side",
    qrLogoSideBySideDescription: "40x40px QR and logo for balanced branding",
    bottomLargeQr: "Bottom Large QR",
    bottomLargeQrDescription: "45x45px QR at bottom, info-first approach",
    ticketPrinted: "Ticket printed successfully",
    repairNumber: "Repair Number",
    thankYou: "Thank you for your business!",
    bringReceipt: "Please bring this receipt when you pick up your device.",
    printTicket: "Print Ticket",
    status: {
      pending: "Pending",
      inProgress: "In Progress",
      completed: "Completed",
      returned: "Returned",
      cancelled: "Cancelled",
    },
    payment: {
      paid: "Paid",
      partial: "Partial",
      unpaid: "Unpaid",
    },
    addError: "Failed to add repair. Please try again.",
    fetchError: "Failed to fetch repairs. Please try again.",
    updateError: "Failed to update repair. Please try again.",
    deleteError: "Failed to delete repair. Please try again.",
    importError: "Failed to import repairs. Please try again.",
    noRepairFoundWithTicket:
      "No repair found with this ticket number. Please check and try again.",
    noTicketNumberForBarcode:
      "No ticket number available for barcode generation.",

    // Email notifications
    sendEmail: "Send Email",
    sendEmailToCustomer: "Send Email to Customer",
    emailSentSuccess: "Email sent successfully",
    emailSentError: "Failed to send email",
    invalidEmailAddress: "Invalid email address",
    emailTemplate: "Email Template",
    completionTemplate: "Repair Completion",
    customTemplate: "Custom Message",
    emailSubject: "Subject",
    emailMessage: "Message",
    enterEmailSubject: "Enter email subject",
    enterEmailMessage: "Enter your message to the customer",
    showPreview: "Show Preview",
    hidePreview: "Hide Preview",
    emailPreview: "Email Preview",
    to: "To",
    subject: "Subject",
    sending: "Sending...",
  },
  searchRepairs: {
    title: "Search Repairs",
    noResults: "No repairs found",
    adjustFilters: "Try adjusting your search or filters",
  },
  filters: {
    title: "Filters",
    slogan: "Filter repairs by status and payment",
    status: "Status",
    payment: "Payment Status",
    clear: "Clear filters",
    anyStatus: "Any status",
    anyPaymentStatus: "Any payment status",
    clearAll: "Clear all filters",
    dateFrom: "From Date",
    dateTo: "To Date",
  },
  importExport: {
    import: "Import",
    export: "Export",
    importRepairs: "Import Repairs",
    exportRepairs: "Export Repairs",
    chooseFile: "Choose File",
    downloadTemplate: "Download Template",
    importedSuccess: "Repairs imported successfully!",
    exportedSuccess: "Repairs exported successfully!",
    invalidFile: "Invalid file format. Please use a valid JSON file.",
    importConfirmation:
      "Are you sure you want to import these repairs? This will overwrite any existing data.",
  },
  analytics: {
    title: "Payment Analytics",
    totalAmountPaid: "Total Amount Paid",
    averageAmountPaid: "Average Amount Paid",
    monthlyRevenue: "Monthly Revenue",
  },
  auth: {
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    loginToContinue: "Login to continue to your account",
    genericError: "An error occurred during login",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    invalidCredentials: "Invalid email or password",
  },
  languageSwitcher: {
    language: "Language",
    english: "English",
    french: "French",
    arabic: "Arabic",
  },
  repairShop: {
    title: "Repair Shop",
    name: "Shop Name",
    address: "Address",
    phone: "Phone",
    fetchError: "Failed to fetch repair shop information",
  },
  scanner: {
    henexScanner: "Dedicated Scanner",
    cameraScanner: "Camera Scanner",
    barcode: "Barcode",
    henexInstructions:
      "Dedicated scanner is active. Scan a barcode or QR code directly.",
    scannerInstructions: "Press the scanner button to scan a code",
    scanPlaceholder: "Scan a code...",
    scanSuccess: "Code scanned successfully!",
    scanError: "Error scanning code. Please try again.",
    autoScanEnabled: "Auto-scanning enabled",
    readyToScan: "Ready to scan",
    scanningActive: "Scanner active",
  },
  shortcuts: {
    title: "Keyboard Shortcuts",
    description: "Use these keyboard shortcuts to navigate quickly",
    keyboard: "Shortcuts",
    showShortcuts: "Show keyboard shortcuts",
    tip: "Press ? anytime to show this help dialog",
    goToDashboard: "Go to Dashboard (Alt+H)",
    newRepair: "Create New Repair (Alt+N)",
    printCurrentRepair: "Print Current Repair (Alt+P)",
    help: "Show Keyboard Shortcuts (?)",
    navigatedToDashboard: "Navigated to Dashboard",
    creatingNewRepair: "Creating new repair",
    printing: "Printing...",
  },
  theme: {
    light: "Light",
    dark: "Dark",
    system: "System",
    toggleDarkMode: "Toggle dark mode",
  },
  dashboard: {
    title: "Dashboard",
    editLayout: "Edit Layout",
    saveLayout: "Save Layout",
    reset: "Reset",
    addWidget: "Add Widget",
    widgetAdded: "Widget added successfully",
    widgetRemoved: "Widget removed",
    dashboardReset: "Dashboard reset to default",
    widgetType: "Widget Type",
    widgetTitle: "Widget Title",
    selectWidgetType: "Select widget type",
    addWidgetDescription: "Choose a widget type and customize its title",
    totalRepairs: "Total Repairs",
    repairs: "Repairs",
    noRepairsFound: "No repairs found",
    unknownDevice: "Unknown Device",
    goodMorning: "Good Morning",
    goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening",
    user: "User",
    welcomeMessage:
      "Welcome to your personalized dashboard. Here you can see an overview of your repair shop.",
    widgets: {
      welcome: {
        title: "Welcome",
        defaultTitle: "Welcome",
      },
      "repair-status": {
        title: "Repair Status",
        defaultTitle: "Repair Status",
      },
      "recent-repairs": {
        title: "Recent Repairs",
        defaultTitle: "Recent Repairs",
      },
      "repairs-by-status": {
        title: "Repairs by Status",
        defaultTitle: "Repairs by Status",
      },
      "repairs-by-device": {
        title: "Repairs by Device",
        defaultTitle: "Repairs by Device",
      },
      "payment-status": {
        title: "Payment Status",
        defaultTitle: "Payment Status",
      },
      income: {
        title: "Income",
        defaultTitle: "Income",
      },
    },
    paid: "Paid",
    unpaid: "Unpaid",
    partial: "Partially Paid",
    noPaymentData: "No payment data available",
    monthlyIncome: "Monthly Income",
    totalIncome: "Total Income",
    income: "Income",
    increase: "increase",
    decrease: "decrease",
    allTime: "All time",
  },
  stock: {
    title: "Stock Management & POS",
    pos: "Point of Sale",
    allCategories: "All Categories",
    allSubcategories: "All Subcategories",
    products: "Products",
    categories: "Categories",
    sales: "Sales",
    inventory: "Inventory",
    reports: "Reports",

    // Product Management
    addProduct: "Add Product",
    editProduct: "Edit Product",
    deleteProduct: "Delete Product",
    productName: "Product Name",
    productDescription: "Description",
    sku: "SKU",
    barcode: "Barcode",
    category: "Category",
    price: "Price",
    cost: "Cost",
    stock: "Stock",
    minStock: "Min Stock",
    maxStock: "Max Stock",
    isActive: "Active",
    image: "Image",

    // Categories
    addCategory: "Add Category",
    editCategory: "Edit Category",
    categoryName: "Category Name",
    categoryDescription: "Category Description",

    // POS Interface
    cart: "Cart",
    addToCart: "Add to Cart",
    removeFromCart: "Remove",
    clearCart: "Clear Cart",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    discount: "Discount",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",

    // Payment
    payment: "Payment",
    paymentMethod: "Payment Method",
    cash: "Cash",
    card: "Card",
    mobile: "Mobile Payment",
    mixed: "Mixed Payment",
    amountPaid: "Amount Paid",
    change: "Change",
    processSale: "Process Sale",

    // Customer
    customer: "Customer",
    customerName: "Customer Name",
    customerPhone: "Customer Phone",

    // Sales
    saleNumber: "Sale #",
    saleDate: "Sale Date",
    saleTotal: "Sale Total",
    viewSale: "View Sale",

    // Inventory
    lowStock: "Low Stock",
    outOfStock: "Out of Stock",
    stockLevel: "Stock Level",
    stockMovement: "Stock Movement",
    stockIn: "Stock In",
    stockOut: "Stock Out",
    adjustment: "Adjustment",

    // Messages
    productAdded: "Product added successfully",
    productUpdated: "Product updated successfully",
    productDeleted: "Product deleted successfully",
    categoryAdded: "Category added successfully",
    categoryUpdated: "Category updated successfully",
    categoryDeleted: "Category deleted successfully",
    saleCompleted: "Sale completed successfully",
    insufficientStock: "Insufficient stock",
    invalidQuantity: "Invalid quantity",
    fetchError: "Error fetching data",
    addError: "Error adding item",
    updateError: "Error updating item",
    deleteError: "Error deleting item",
    saleError: "Error processing sale",
    stockAdjusted: "Stock adjusted successfully",
    adjustError: "Error adjusting stock",

    // Touch Interface
    touchMode: "Touch Mode",
    gridView: "Grid View",
    listView: "List View",
    searchProducts: "Search products...",

    // Barcode Scanner
    scan: "Scan",
    scanBarcode: "Scan Barcode",
    barcodeScanner: "Barcode Scanner",
    manualEntry: "Manual Entry",
    cameraScanner: "Camera Scanner",
    enterBarcode: "Enter Barcode",
    productNotFound: "Product not found",
    productInactive: "Product is inactive",
    productOutOfStock: "Product is out of stock",
    barcodeAdded: "Product added to cart via barcode",
    scannerActive: "Scanner Active - Ready to scan",
    scanning: "Scanning",
    scannerInstructions: "Automatic barcode scanning is active:",
    useBarcodeScannerDevice: "Use barcode scanner",
    typeBarcodeDirect: "Type barcode directly",
    automaticCartAdd: "Auto-adds to cart",
    cameraStarted: "Camera started. Point at barcode to scan.",
    cameraError: "Could not access camera. Please use manual input.",
    enterBarcodeManually: "Enter Barcode Manually",
    enterOrScanBarcode: "Enter or scan barcode...",
    pointCameraAtBarcode: "Point camera at barcode to scan",
    orTypeBarcodeHere: "Or type barcode here...",
    cameraNotStarted: "Camera not started",
    startCamera: "Start Camera",

    // Sales Ticket & Printing
    salesTicket: "Sales Ticket",
    printTicket: "Print Ticket",
    print: "Print",
    thankYouVisit: "Thank you for your visit!",
    keepTicket: "Please keep this ticket for your records",
    printInstructions1: "Optimized for 80mm thermal printers",
    printInstructions2: "Ensure printer is connected and ready",
    printInstructions3: "Click Print to generate receipt",

    // Sales History
    todaysSales: "Today's Sales",
    todaysRevenue: "Today's Revenue",
    totalSales: "Total Sales",
    noSalesYet: "No sales yet",
    walkInCustomer: "Walk-in Customer",
    saleId: "Sale ID",
    totalValue: "Total Value",
    noLowStockItems: "No low stock items",
    noOutOfStockItems: "No out of stock items",

    // Empty States
    emptyCart: {
      title: "Your cart is empty",
      subtitle: "Add products to get started",
      action: "Browse Products",
      tip: "Scan a barcode or click on products to add them",
    },
    emptyProducts: {
      title: "No products found",
      subtitle: "Try adjusting your search or category filter",
      action: "Clear Filters",
      tip: "Make sure products are added to your inventory",
    },

    // Daily Summary
    dailySummary: "Daily Summary",
    totalRevenue: "Total Revenue",
    transactions: "Transactions",
    avgTransaction: "Avg Transaction",
    itemsSold: "Items Sold",
    paymentBreakdown: "Payment Methods",
    peakHour: "Peak Hour",
    printSummary: "Print Summary",
    exportSummary: "Export Summary",
    selectDateRange: "Select Date Range",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    customRange: "Custom Range",
    from: "From",
    to: "To",
    apply: "Apply",

    // Product Management
    showInactive: "Show Inactive",
    hideInactive: "Hide Inactive",
    inactive: "Inactive",

    // Barcode Sticker
    generateSticker: "Generate Sticker",
    printSticker: "Print Sticker",
    preparingPrint: "Preparing print...",
    generateBarcode: "Generate Barcode",
    generateEAN13Barcode: "Generate EAN13 Barcode",
    barcodeSticker: "Barcode Sticker",
    stickerPreview: "Sticker Preview",
    copies: "Copies",
    productNeedsBarcode: "This product needs a barcode",
    addBarcodeToProduct: "Add a barcode to this product to print stickers",
    downloadSticker: "Download Sticker",
    saveBarcodeToProduct: "Save Barcode to Product",
    barcodeGenerated: "Barcode generated successfully",
    barcodeSaved: "Barcode saved to product successfully",
    noBarcodeToSave: "No barcode to save",
    failedToGenerateBarcode: "Failed to generate barcode",
    failedToSaveBarcode: "Failed to save barcode to product",
    productHasBarcode: "Has Barcode",
    productNoBarcode: "No Barcode",
    generateNewBarcode:
      "This product doesn't have a barcode. Generate one below.",
    tryAdjustingSearch: "Try adjusting your search terms",
    getStartedAddProduct: "Get started by adding your first product",

    // Sticker Configuration
    stickerSettings: "Sticker Settings",
    configureStickerSettings: "Configure Sticker Settings",
    paperSize: "Paper Size",
    customSize: "Custom Size",
    width: "Width",
    height: "Height",
    displayOptions: "Display Options",
    showProductName: "Show Product Name",
    showSKU: "Show SKU",
    showPrice: "Show Price",
    showBarcode: "Show Barcode",
    showCategory: "Show Category",
    showDescription: "Show Description",
    fontSizes: "Font Sizes",
    productNameSize: "Product Name Size",
    priceSize: "Price Size",
    skuSize: "SKU Size",
    otherTextSize: "Other Text Size",
    barcodeHeight: "Barcode Height",
    margin: "Margin",
    resetToDefaults: "Reset to Defaults",
    stickerConfigSaved: "Sticker configuration saved",
    stickerConfigReset: "Sticker configuration reset to defaults",

    // POS Interface Messages
    cartIsEmpty: "Cart is empty",
    insufficientPayment: "Insufficient payment amount",
    saleFailed: "Sale failed",
    unknownError: "Unknown error",
    saleProcessedSuccessfully: "Sale processed successfully!",

    // Quick Setup
    userOrShopNotFound: "User or repair shop not found",
    errorCheckingSetup: "Error checking setup",
    errorCreatingSampleData: "Error creating sample data",
    sampleDataCreatedSuccessfully: "Sample data created successfully!",
    checking: "Checking...",
    checkSetup: "Check Setup",
    createSampleData: "Create Sample Data",

    // Product Form
    priceAndCostMustBePositive: "Price and cost must be positive numbers",
    enterProductName: "Enter product name",
    enterSKU: "Enter SKU",
    enterProductDescription: "Enter product description",

    // Stock Validation Messages
    productNoLongerExists: "Product no longer exists",
    productNoLongerActive: "Product is no longer active",
    insufficientStockDetailed:
      "Insufficient stock for {{productName}}. Available: {{available}}, Required: {{required}}",

    // Advanced POS Features
    holdOrder: "Hold Order",
    heldOrders: "Held Orders",
    recallOrder: "Recall Order",
    deleteOrder: "Delete Order",
    orderHeld: "Order held successfully",
    orderRecalled: "Order recalled successfully",
    orderDeleted: "Order deleted successfully",
    applyDiscount: "Apply Discount",
    orderDiscount: "Order Discount",
    itemDiscount: "Item Discount",
    discountType: "Discount Type",
    percentage: "Percentage",
    fixedAmount: "Fixed Amount",
    discountValue: "Discount Value",
    discountApplied: "Discount applied successfully",
    notes: "Notes",
    addNotes: "Add Notes",
    orderNotes: "Order Notes",
    noHeldOrders: "No held orders",
    heldOn: "Held on",
    orderTotal: "Order Total",
    discountAmount: "Discount Amount",

    // Password Protection
    confirmProductCreation: "Confirm Product Creation",
    confirmProductUpdate: "Confirm Product Update",
    confirmProductDeletion: "Confirm Product Deletion",
    confirmCategoryCreation: "Confirm Category Creation",
    confirmCategoryUpdate: "Confirm Category Update",
    confirmCategoryDeletion: "Confirm Category Deletion",
    productCreationWarning:
      "This action will create a new product in your inventory. Please enter the access code to continue.",
    productUpdateWarning:
      "This action will modify an existing product in your inventory. Please enter the access code to continue.",
    productDeletionWarning:
      "This action will permanently delete the product from your inventory. This cannot be undone. Please enter the access code to continue.",
    categoryCreationWarning:
      "This action will create a new category in your inventory. Please enter the access code to continue.",
    categoryUpdateWarning:
      "This action will modify an existing category in your inventory. Please enter the access code to continue.",
    categoryDeletionWarning:
      "This action will permanently delete the category from your inventory. This cannot be undone. Please enter the access code to continue.",
    updateProduct: "Update Product",
    updateCategory: "Update Category",
    deleteCategory: "Delete Category",
    cannotDeleteCategory:
      "Cannot delete category. It contains {{count}} products. Please move or delete the products first.",

    // Subcategories
    subcategories: "Subcategories",
    subcategory: {
      name: "Subcategory Name",
      description: "Description",
      icon: "Icon",
      color: "Color",
      add: "Add Subcategory",
      edit: "Edit Subcategory",
      created: "Subcategory Created",
      createdDescription: "The subcategory has been created successfully.",
      updated: "Subcategory Updated",
      updatedDescription: "The subcategory has been updated successfully.",
      deleted: "Subcategory Deleted",
      deletedDescription: "The subcategory has been deleted successfully.",
      createError: "Failed to create subcategory",
      updateError: "Failed to update subcategory",
      deleteError: "Failed to delete subcategory",
      searchPlaceholder: "Search subcategories...",
      namePlaceholder: "Enter subcategory name",
      descriptionPlaceholder: "Enter subcategory description",
      iconPlaceholder: "Enter emoji or icon",
      empty:
        "No subcategories found. Create your first subcategory to get started.",
      noResults: "No subcategories match your search criteria.",
      selectSubcategory: "Select Subcategory",
    },
  },
  invoices: {
    title: "Invoices",
    create: "Create Invoice",
    clientManagement: "Client Management",
    clientManagementDescription:
      "Manage your clients and their credit information",
    edit: "Edit Invoice",
    view: "View Invoice",
    viewInvoice: "View Invoice",
    delete: "Delete Invoice",
    invoiceNumber: "Invoice Number",
    client: "Client",
    clientInformation: "Client Information",
    amount: "Amount",
    status: "Status",
    paymentStatus: "Payment Status",
    dueDate: "Due Date",
    createdAt: "Created At",
    createdOn: "Created on",
    invoiceDate: "Invoice Date",
    invoiceDetails: "Invoice Details",
    paymentSummary: "Payment Summary",
    items: "Items",
    item: "Item",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    discount: "Discount",
    total: "Total",
    subtotal: "Subtotal",
    tax: "Tax",
    taxRate: "Tax Rate",
    notes: "Notes",
    termsAndConditions: "Terms and Conditions",
    downloadPDF: "Download PDF",
    printPDF: "Print PDF",
    previewPDF: "Preview PDF",
    invoicePreview: "Invoice Preview",
    pdfDownloadSuccess: "PDF downloaded successfully",
    pdfDownloadError: "Failed to download PDF",
    pdfPrintSuccess: "Invoice sent to printer successfully",
    pdfPrintError: "Failed to print invoice",
    sendEmail: "Send Email",
    recordPayment: "Record Payment",
    paidAmount: "Paid Amount",
    remainingAmount: "Remaining Amount",

    // Status labels
    statusLabels: {
      draft: "Draft",
      sent: "Sent",
      paid: "Paid",
      overdue: "Overdue",
      cancelled: "Cancelled",
    },

    // Payment status labels
    paymentStatusLabels: {
      unpaid: "Unpaid",
      partial: "Partially Paid",
      paid: "Paid",
      overpaid: "Overpaid",
    },

    // Messages
    created: "Invoice Created",
    createdDescription: "The invoice has been created successfully.",
    updated: "Invoice Updated",
    updatedDescription: "The invoice has been updated successfully.",
    deleted: "Invoice Deleted",
    deletedDescription: "The invoice has been deleted successfully.",
    createError: "Failed to create invoice",
    updateError: "Failed to update invoice",
    deleteError: "Failed to delete invoice",
    fetchError: "Failed to fetch invoices",

    // Search and filters
    searchPlaceholder: "Search invoices...",
    selectStatus: "Select Status",
    empty: "No invoices found. Create your first invoice to get started.",
    noResults: "No invoices match your search criteria.",

    // Payment tracking
    paymentTracking: "Payment Tracking",
    paymentProgress: "Payment Progress",
    paymentCount: "Payments",
    lastPayment: "Last Payment",
    recentPayments: "Recent Payments",
    viewAll: "View All",
    addPayment: "Add Payment",
    viewHistory: "View History",
    overdueBy: "Overdue by {{days}} days",

    // Payment form
    invoiceSummary: "Invoice Summary",
    paymentDate: "Payment Date",
    paymentMethod: "Payment Method",
    paymentAmount: "Payment Amount",
    selectPaymentMethod: "Select payment method",
    referenceNumber: "Reference Number",
    referenceNumberPlaceholder: "Check number, transaction ID, etc.",
    paymentNotes: "Payment Notes",
    paymentNotesPlaceholder: "Add any notes about this payment...",
    overpaymentWarning:
      "This payment exceeds the remaining balance by {{excess}}",
    fullPaymentNotice: "This payment will fully settle the invoice",
    afterPayment: "Remaining after payment",
    payFull: "Pay Full Amount",
    payHalf: "Pay Half",

    // Payment methods
    paymentMethods: {
      cash: "Cash",
      card: "Card",
      mobile: "Mobile Payment",
      bankTransfer: "Bank Transfer",
      check: "Check",
      other: "Other",
    },

    // Payment history
    paymentHistory: "Payment History",
    totalPaid: "Total Paid",
    averagePayment: "Average Payment",
    searchPayments: "Search payments...",
    filterByMethod: "Filter by method",
    sortBy: "Sort by",
    newestFirst: "Newest First",
    oldestFirst: "Oldest First",
    highestAmount: "Highest Amount",
    lowestAmount: "Lowest Amount",
    paymentMethodBreakdown: "Payment Method Breakdown",
    paymentRecords: "Payment Records",
    noPaymentsYet: "No payments recorded yet",
    noPaymentsMatchFilter: "No payments match your filter criteria",
    date: "Date",
    method: "Method",
    reference: "Reference",

    // Payment operation messages
    paymentRecorded: "Payment recorded successfully",
    paymentRecordError: "Failed to record payment",
    paymentUpdated: "Payment updated successfully",
    paymentUpdateError: "Failed to update payment",
    paymentDeleted: "Payment deleted successfully",
    paymentDeleteError: "Failed to delete payment",

    // Dashboard and overview
    subtitle: "Manage invoices, payments, and templates",
    totalInvoices: "Total Invoices",
    totalInvoicesDescription: "All invoices created",
    totalRevenue: "Total Revenue",
    totalRevenueDescription: "Total invoiced amount",
    paidAmountDescription: "Amount received",
    outstandingAmount: "Outstanding",
    outstandingAmountDescription: "Amount pending",
    overdueInvoices: "Overdue",
    overdueInvoicesDescription: "Past due invoices",

    // Tabs and sections
    invoices: "Invoices",
    payments: "Payments",
    templates: "Templates",
    clients: "Clients",
    paymentOverview: "Payment Overview",
    paymentOverviewPlaceholder:
      "Payment analytics and reports will be displayed here",
    paymentOverviewDescription:
      "Track payment trends and analyze revenue patterns",
    clientManagement: "Client Management",
    clientManagementPlaceholder:
      "Client management interface will be displayed here",
    clientManagementDescription:
      "Manage client information and payment history",
    totalClients: "Total Clients",
    clientsCount: "{{count}} clients registered",
    addClient: "Add Client",

    // Templates section
    templateName: "Template Name",
    templateNamePlaceholder: "Enter template name",
    description: "Description",
    descriptionPlaceholder: "Enter template description",
    activeTemplate: "Active Template",
    activeTemplateDescription: "Template is available for use",
    defaultTemplate: "Default Template",
    defaultTemplateDescription: "Use as default for new invoices",
    companyInformation: "Company Information",
    companyName: "Company Name",
    companyNamePlaceholder: "Enter company name",
    companyLogo: "Company Logo",
    companyLogoPlaceholder: "Enter logo URL",
    companyPhone: "Company Phone",
    companyPhonePlaceholder: "Enter phone number",
    companyEmail: "Company Email",
    companyEmailPlaceholder: "Enter email address",
    companyWebsite: "Company Website",
    companyWebsitePlaceholder: "Enter website URL",
    companyTaxId: "Tax ID",
    companyTaxIdPlaceholder: "Enter tax identification number",
    companyAddress: "Company Address",
    companyAddressPlaceholder: "Enter company address",
    designSettings: "Design Settings",
    primaryColor: "Primary Color",
    secondaryColor: "Secondary Color",
    fontFamily: "Font Family",
    selectFont: "Select font",
    fontSize: "Font Size",
    footerText: "Footer Text",
    footerTextPlaceholder: "Enter footer text",
    layoutSettings: "Layout Settings",
    showLogo: "Show Logo",
    showLogoDescription: "Display company logo on invoices",
    showCompanyInfo: "Show Company Info",
    showCompanyInfoDescription: "Display company information",
    showTaxBreakdown: "Show Tax Breakdown",
    showTaxBreakdownDescription: "Display detailed tax calculations",
    showPaymentTerms: "Show Payment Terms",
    showPaymentTermsDescription: "Display payment terms and conditions",
    showNotes: "Show Notes",
    showNotesDescription: "Display notes section on invoices",
    templateManagement: "Template Management",
    templateManagementDescription: "Create and manage invoice templates",

    // Payment Overview
    fromInvoices: "from {{count}} invoices",
    collectedAmount: "Collected Amount",
    collectionRate: "collection rate",
    pendingInvoices: "pending invoices",
    requiresAttention: "requires attention",
    searchInvoices: "Search invoices...",
    selectPaymentStatus: "Select payment status",
    selectPeriod: "Select period",
    allTime: "All time",
    last7Days: "Last 7 days",
    last30Days: "Last 30 days",
    last90Days: "Last 90 days",
    exportPayments: "Export Payments",
    noPaymentsFound: "No payments found",

    // Bulk actions
    selectedCount: "{{count}} selected",
    bulkActions: "Bulk Actions",
    markAsSent: "Mark as Sent",
    markAsPaid: "Mark as Paid",
    sendBulkEmail: "Send Bulk Email",
    updateOverdue: "Update Overdue",

    // Form fields
    selectClient: "Select Client",
    selectTemplate: "Select Template",
    addItem: "Add Item",
    itemName: "Item Name",
    itemDescription: "Item Description",

    // Templates section
    templates: "Templates",

    // Table headers and labels (to avoid conflicts with status objects)
    statusHeader: "Status",
    paymentStatusHeader: "Payment Status",
    statusLabel: "Status",
    paymentStatusLabel: "Payment Status",
  },
  templates: {
    title: "Invoice Templates",
    create: "Create Template",
    edit: "Edit Template",
    delete: "Delete Template",
    duplicate: "Duplicate Template",
    preview: "Preview Template",
    setAsDefault: "Set as Default",
    name: "Template Name",
    description: "Description",
    company: "Company",
    colors: "Colors",
    status: "Status",
    lastModified: "Last Modified",
    searchPlaceholder: "Search templates...",
    filterByStatus: "Filter by status",
    default: "Default",
    defaultTemplate: "Default Template",
    noDescription: "No description",
    noCompanyInfo: "No company info",
    noResults: "No templates match your search criteria",
    empty: "No templates found. Create your first template to get started.",
    totalTemplates: "{{count}} templates total",
    activeTemplates: "{{count}} active",
    defaultTemplates: "{{count}} default",
    deleteTemplate: "Delete Template",
    deleteConfirmation:
      "Are you sure you want to delete the template '{{name}}'? This action cannot be undone.",
    cannotDeleteDefault: "Cannot Delete Default Template",
    cannotDeleteDefaultDescription:
      "You cannot delete the default template. Please set another template as default first.",
    cannotSetInactiveDefault: "Cannot Set Inactive Template as Default",
    cannotSetInactiveDefaultDescription:
      "You cannot set an inactive template as default. Please activate the template first.",
  },
  common: {
    dashboard: "Dashboard",
    newRepair: "New Repair",
    search: "Search",
    stock: "Stock & POS",
    searchRepairs: "Search Repairs",
    viewDetails: "View Details",
    clickToView: "Click to view",
    processing: "Processing...",
    submit: "Submit",
    cancel: "Cancel",
    delete: "Delete",
    optional: "optional",
    areYouSure: "Are you sure?",
    back: "Back to",
    loading: "Loading...",
    print: "Print",
    download: "Download",
    balance: "Balance",
    error: "Error!",
    info: "Info",
    pageNotFound: "Oops! Page not found",
    returnHome: "Return to Home",
    copied: "Copied to clipboard",
    call: "Call",
    startScanning: "Start Scanning",
    stopScanning: "Stop Scanning",
    scannerActive: "Scanner is active and ready",
    scannerInactive: "Scanner is inactive",
    logo: "Logo",
    repairShop: "Repair Shop",
    tel: "Tel",
    phone: "Phone",
    clear: "Clear",
    edit: "Edit",
    disabled: "Disabled",
    featureDisabledMessage: "This feature has been disabled for this store.",
    enterSecurityCode: "Enter security code",
    invalidSecurityCode: "Invalid security code. Please try again.",
    none: "None",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    status: "Status",
    actions: "Actions",
    save: "Save",
    saving: "Saving...",
    confirm: "Confirm",
    securityVerification: "Security Verification",
    enterSecurityCodeToConfirm:
      "Please enter the security code to confirm this action.",
    unknown: "Unknown",
    refresh: "Refresh",
    sDescription: "Display invoice notes section",
    showPageNumbers: "Show Page Numbers",
    showPageNumbersDescription: "Display page numbers on printed invoices",
    customFields: "Custom Fields",
    addCustomField: "Add Custom Field",
    fieldName: "Field Name",
    fieldNamePlaceholder: "Enter field name",
    fieldLabel: "Field Label",
    fieldLabelPlaceholder: "Enter field label",
    fieldType: "Field Type",
    fieldTypes: {
      text: "Text",
      number: "Number",
      date: "Date",
      boolean: "Yes/No",
      select: "Dropdown",
    },
    required: "Required",
    basicInformation: "Basic Information",
    basic: "Basic",
    company: "Company",
    design: "Design",
    layout: "Layout",
    create: "Create Template",
    createTemplate: "Create Template",
    editTemplate: "Edit Template",
    preview: "Preview",
    duplicate: "Duplicate",
    setAsDefault: "Set as Default",
    searchPlaceholder: "Search templates...",
    filterByStatus: "Filter by status",
    name: "Name",
    colors: "Colors",
    lastModified: "Last Modified",
    noDescription: "No description",
    noCompanyInfo: "No company info",
    noResults: "No templates match your search criteria",
    empty: "No templates found. Create your first template to get started.",
    deleteTemplate: "Delete Template",
    deleteConfirmation:
      "Are you sure you want to delete the template '{{name}}'? This action cannot be undone.",
    cannotDeleteDefault: "Cannot Delete Default Template",
    cannotDeleteDefaultDescription:
      "You cannot delete the default template. Please set another template as default first.",
    cannotSetInactiveDefault: "Cannot Set Inactive Template as Default",
    cannotSetInactiveDefaultDescription:
      "Please activate the template first before setting it as default.",
    totalTemplates: "{{count}} templates total",
    activeTemplates: "{{count}} active",
    defaultTemplates: "{{count}} default",

    // Template operation messages
    templateCreated: "Template created successfully",
    templateCreateError: "Failed to create template",
    templateUpdated: "Template updated successfully",
    templateUpdateError: "Failed to update template",
    templateDeleted: "Template deleted successfully",
    templateDeleteError: "Failed to delete template",
    templateFetchError: "Failed to fetch templates",
    templateCloned: "Template cloned successfully",
    templateCloneError: "Failed to clone template",
    templateSetAsDefault: "Template set as default successfully",
    templateSetDefaultError: "Failed to set template as default",
    templateActivated: "Template activated successfully",
    templateDeactivated: "Template deactivated successfully",
    templateStatusError: "Failed to update template status",

    // Enhanced invoice management
    selectPaymentStatus: "Select Payment Status",
    remaining: "Remaining",
    updateOverdue: "Update Overdue",
    selectedCount: "{{count}} selected",
    bulkActions: "Bulk Actions",
    markAsSent: "Mark as Sent",
    markAsPaid: "Mark as Paid",
    sendBulkEmail: "Send Bulk Email",
    bulkUpdateSuccess: "Bulk update completed",
    bulkUpdateSuccessDescription: "{{count}} invoices updated to {{status}}",
    bulkUpdateError: "Failed to update invoices",
    bulkEmailNotImplemented:
      "Bulk email functionality will be implemented in the next task",
    overdueUpdated: "Overdue invoices updated",
    overdueUpdatedDescription: "{{count}} invoices marked as overdue",
    overdueUpdateError: "Failed to update overdue invoices",
    statusUpdated: "Invoice status updated",
    statusUpdatedDescription: "Invoice status changed to {{status}}",
    statusUpdateError: "Failed to update invoice status",
    clickToChangeStatus: "Click to change status",
  },
  clients: {
    title: "Clients",
    subtitle: "Manage your clients and their information",

    // Actions
    addClient: "Add Client",
    editClient: "Edit Client",
    viewClient: "View Client",
    deleteClient: "Delete Client",

    // Form fields
    clientName: "Client Name",
    clientNameRequired: "Client name is required",
    phone: "Phone Number",
    email: "Email Address",
    address: "Address",
    notes: "Notes",
    creditLimit: "Credit Limit",
    creditLimitDescription: "Maximum credit amount allowed for this client",
    isActive: "Active Client",
    isActiveDescription:
      "Inactive clients won't appear in client selection lists",

    // Status and badges
    active: "Active",
    inactive: "Inactive",
    hasCredit: "Has Credit",

    // Credit information
    currentBalance: "Current Balance",
    availableCredit: "Available Credit",
    creditUtilization: "Credit Utilization",

    // Client details
    contactInformation: "Contact Information",
    creditInformation: "Credit Information",
    invoiceSummary: "Invoice Summary",
    invoiceHistory: "Invoice History",
    creditManagement: "Credit Management",

    // Invoice summary
    totalInvoices: "Total Invoices",
    totalAmount: "Total Amount",
    paidInvoices: "Paid Invoices",
    unpaidAmount: "Unpaid Amount",

    // Messages
    noClients: "No clients found.",
    noClientsDescription: "Create your first client to get started.",
    noSearchResults: "No clients found matching your search.",
    noInvoices: "No invoices found for this client.",

    // Search and filters
    searchPlaceholder: "Search clients...",

    // Success messages
    createSuccess: "Client created successfully",
    updateSuccess: "Client updated successfully",
    deleteSuccess: "Client deactivated successfully",

    // Error messages
    createError: "Failed to create client",
    updateError: "Failed to update client",
    deleteError: "Failed to delete client",
    fetchError: "Failed to fetch clients",

    // Validation messages
    invalidEmail: "Invalid email format",
    nameTooLong: "Client name must be less than 255 characters",
    phoneTooLong: "Phone number must be less than 50 characters",
    negativeCreditLimit: "Credit limit cannot be negative",

    // Delete confirmation
    deleteConfirmTitle: "Delete Client",
    deleteConfirmDescription:
      "Are you sure you want to delete this client? This will deactivate the client and they won't appear in client selection lists. This action cannot be undone.",

    // Tabs
    overview: "Overview",
    invoices: "Invoices",
    credit: "Credit Management",

    // Credit management placeholder
    creditManagementPlaceholder:
      "Credit management features will be available in a future update. This will include credit transaction history, payment plans, and balance adjustments.",
  },
};

export default translations;
